<template>
  <div class="container">
    <div class="title" v-if="!esEdicion">{{ $t('ARCHIVOS_nuevo_archivo') }}</div>
    <div class="title" v-else>{{ $t('ARCHIVOS_editar_archivo') }}</div>
    <!-- <div class="title" v-else>{{ $t('ARCHIVOS_archivo_guardado') }}</div> -->
    
      <!-- Secci�n carga de archivo -->
      <el-row v-show="cargandoArchivo">
        <div  class="loader">
          <el-icon class="is-loading primary"><Loading /></el-icon>
          <div class="primary text-loader">{{$t('GENERAL_cargando')}} {{ $t('ARCHIVOS_archivo')}}</div>
        </div>  
      </el-row>
      <el-row v-show="!cargandoArchivo">
        <el-col :span="24">
          <el-card class="cardArchivo">
            <div class="cardTitle">{{$t('ARCHIVOS_datos_archivo')}}</div>
            
            <el-row>
              <div class="label">{{$t('ARCHIVOS_nombre')}}</div>
              <el-input :placeholder="$t('ARCHIVOS_nombre')" :rows="1" v-model="archivo.nombre" />
            </el-row>
            
            <el-row>
              <div class="label">{{$t('ARCHIVOS_descripcion')}}</div>
              <el-input
                :placeholder="$t('ARCHIVOS_descripcion')"
                type="textarea"
                :rows="2"
                v-model="archivo.descripcion"
              />
            </el-row>

            <el-row type="flex" align="center">
              <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                <div class="label">{{$t('ARCHIVOS_ubicacion')}}</div>
                <el-cascader 
                  class="cascader"
                  ref="cascader"
                  :options="jerarquiaCarpetas"
                  v-model="archivo.arrayUbicacion"
                  :props="propsOptionsCascader"
                  :placeholder="$t('ARCHIVOS_ubicacion')">
                  <template #default="{ node, data }">
                    <span>{{ data.Nombre }}</span>
                    <span v-if="!node.isLeaf"> ({{ data.Hijos.length }}) </span>
                  </template>
                </el-cascader>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                <el-checkbox
                  style="margin-top:45px !important; margin-left:20px !important"
                  v-model="archivo.heredaPermisos"
                  :disabled="ubicacionEsRoot"
                  >{{$t('ARCHIVOS_heredar_permisos')}}
                </el-checkbox>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                <el-select v-model="archivo.tipoArchivo" 
                  :placeholder="$t('ARCHIVOS_seleccionTipo')" 
                  style="margin-top:30px !important"
                >
                  <el-option
                    v-for="tipoArchivo in tiposArchivo"
                    :key="tipoArchivo.label"
                    :label="$t(tipoArchivo.label)"
                    :value="tipoArchivo.value"
                  >
                  </el-option>
                </el-select>
                <!-- <el-checkbox
                  style="margin-top:45px !important"
                  v-model="archivo.esArchivo"
                  :disabled="esEdicion"
                  >{{$t('ARCHIVOS_es_archivo')}}
                </el-checkbox> -->
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                <el-checkbox
                  style="margin-top:45px !important"
                  v-model="archivo.esPublico"
                  :disabled="seleccionUsuarios.length > 0 || seleccionPerfiles.length > 0"
                  >{{$t('ARCHIVOS_publico')}}
                </el-checkbox>
              </el-col>
            </el-row>

            <transition name="el-fade-in-linear">
              <div v-show="archivo.esArchivo">
                <el-row>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="label">{{$t('ARCHIVOS_fecha_vencimiento')}}</div>
                    <el-date-picker
                      class="seleccionador"
                      v-model="archivo.fecha_vencimiento"
                      type="date"
                      size="small"
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      suffix-icon="Calendar"
                    />
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="label">{{$t('ARCHIVOS_archivo')}}</div>
                    <div v-if="archivo.tipoArchivo == this.tiposArchivo.find(x => x.tipo == 'link').value">
                      <el-input size="small" :placeholder="$t('ARCHIVOS_ingresoLink')" v-model="archivo.link"></el-input>
                    </div>
                    <div v-else>
                      <FileUpload
                        class="fileUploadButton"
                        style="text-align:left"
                        name="archivo"
                        labelTag="FILE_UPLOAD_cargar_archivo"
                        :limit="1"
                        :files="archivoCargado"
                        :showPreview="true"
                        :storeAction="'archivos/uploadArchivo'"
                        :onFileListChange="onArchivoChanged"
                        :temporalId="idTemporal"
                        :accept="',.pdf,.zip,.jpg,.png'"
                      />
                    </div>
                    
                  </el-col>
                </el-row> 
              </div>
            </transition>
          </el-card>
        </el-col>
      </el-row>

      <!-- Secci�n permisos de archivo -->
      <div v-if="!archivo.esPublico"> 
        <el-row :gutter="10" style="margin-top:15px">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-card class="cardArchivo">
              <div class="cardTitle" style="margin-bottom:10px">{{$t('ARCHIVOS_permisos_perfiles')}}</div>
              <div v-if="dataPerfiles === undefined" class="loader">
                <el-icon class="is-loading primary"><Loading /></el-icon>
                <div class="primary text-loader">{{$t('GENERAL_cargando')}} {{ $t('ARCHIVOS_permisos_perfiles')}}</div>
              </div>
              <div v-else>
                <el-transfer 
                  class="transferClass"
                  ref="transferPerfiles"
                  filterable
                  :filter-placeholder="$t('ARCHIVOS_perfiles_filtro_placeholder')"
                  :titles="[$t('ARCHIVOS_listas_todos'),$t('ARCHIVOS_listas_elegidos')]"
                  v-model="valuePerfiles"
                  :props="propsDataPerfiles"
                  :data="dataPerfiles"
                  @change="cambioSeleccionPerfiles">
                </el-transfer>
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-card class="cardArchivo">
              <div class="cardTitle" style="margin-bottom:10px">{{$t('ARCHIVOS_permisos_usuarios')}}</div>
              <div v-if="dataUsuarios === undefined" class="loader">
                <el-icon class="is-loading primary"><Loading /></el-icon>
                <div class="primary text-loader">{{$t('GENERAL_cargando')}} {{ $t('ARCHIVOS_permisos_usuarios')}}</div>
              </div>
              <div v-else>
                <el-transfer 
                  class="transferClass"
                  ref="transferUsuarios"
                  filterable
                  :filter-placeholder="$t('ARCHIVOS_usuarios_filtro_placeholder')"
                  :titles="[$t('ARCHIVOS_listas_todos'),$t('ARCHIVOS_listas_elegidos')]"
                  v-model="valueUsuarios"
                  :props="propsDataUsuarios"
                  :data="dataUsuarios"
                  @change="cambioSeleccionUsuarios">
                </el-transfer>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- Secci�n botones Guardar y Cancelar -->
      <el-row>
        <div class="btnContainer">
          <el-button type="primary" @click="save" :loading="guardando">{{ $t('GENERAL_saveBtn') }}</el-button>
          <router-link :to="{ name: 'Archivos'}">
            <el-button>{{ $t('GENERAL_cancelBtn') }}</el-button>
          </router-link>
        </div>
      </el-row>
    </div>
</template>

<script>
import FileUpload from "../FileUpload/index"
import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado"
import { showError, showSuccess } from "../Mensaje"


export default {
  components: { FileUpload },
  data() {
    return {
      archivoTemporal: undefined, // variable para guardar los datos del archivo hasta que se recupere la jerarquia
      archivo: {
        id: 0,
        nombre: "",
        descripcion: "",
        permisosPerfil: undefined,
        permisosUsuario: undefined,
        fecha_vencimiento: undefined,
        esPublico: undefined,
        esArchivo: undefined,
        tipoArchivo: undefined,
        heredaPermisos: undefined,
        arrayUbicacion: [0],
        link: undefined
      },
      cargandoArchivo: true,
      esEdicion: false,
      archivoCargado: [],
      idTemporal: new Date().getTime().toString(),
      guardando: false,

      dataPerfiles: undefined,
      dataUsuarios: undefined,
      valuePerfiles: [],
      valueUsuarios: [],
      propsDataPerfiles: {key: 'Id', label: 'Nombre'},
      propsDataUsuarios: {key: 'Id', label: 'NombreCompleto'},
      seleccionPerfiles: [],
      seleccionUsuarios: [],

      propsOptionsCascader: {value: 'Id', label: 'Nombre', children: 'Hijos', checkStrictly: true, expandTrigger: 'hover'},
      jerarquiaCarpetas: [],
      destinoRecursivo: [],
      tiposArchivo: [
         {
          label: 'ARCHIVOS_carpeta',
          value: 0,
          tipo: 'carpeta',
          esArchivo: false
        },
        {
          label: 'ARCHIVOS_archivo',
          value: 1,
          tipo: 'archivo',
          esArchivo: true
        },
        {
          label: 'ARCHIVOS_link',
          value: 2,
          tipo: 'link',
          esArchivo: true
        },
      ]
    };
  },
  
  watch: {
    'archivo.tipoArchivo'(newValue)
    {
        this.archivo.esArchivo = this.tiposArchivo.find(tipo => tipo.value == newValue).esArchivo;
    },
    seleccionPerfiles() {
      if(this.seleccionPerfiles.length > 0)
        this.archivo.esPublico = false;
    },

    seleccionUsuarios() {
      if(this.seleccionUsuarios.length > 0)
        this.archivo.esPublico = false;
    },
  },

  computed: {
    ubicacionEsRoot: function() {
      return this.archivo.arrayUbicacion.length == 1;
    },
  },

  methods: {
    getPerfiles() {
      this.$store.dispatch("app/getPerfiles")
      .then(data => {this.dataPerfiles = data ? data : []});
    },

    getUsuarios() {
      this.$store.dispatch("app/getUsuarios")
      .then(data => {this.dataUsuarios = data ? data : []});
    },

    getJerarquiaCarpetas() {
      return this.$store.dispatch("archivos/getJerarquiaCarpetas")
      .then(data => {
        this.jerarquiaCarpetas = data.Datos ? data.Datos : [];
        this.quitarHijosVacios(this.jerarquiaCarpetas);
        this.agregarRaiz();
      })
    },

    cambioSeleccionPerfiles(value, direction, movedKeys) {
      let result = [];
      // si se movieron elementos hacia la derecha o si se esta editando un archivo, 
      // agrego los elementos movidos (o los ya seleccionados) al array de perfiles seleccionados
      if (direction == "right") {
        for (let i=0; i<movedKeys.length; i++) {
          result = this.dataPerfiles.filter(x => {
            return x.Id == movedKeys[i]
          });

          this.seleccionPerfiles.push(result[0]);
        }
      }

      // si se movieron elementos hacia la izquierda, los quito del array de perfiles seleccionados
      if (direction == "left") {
        for (let i=0; i<movedKeys.length; i++) {
          this.seleccionPerfiles.splice(
            this.seleccionPerfiles.findIndex((x) => x.Id == movedKeys[i]),
            1
          );
        }
      }
    },

    cambioSeleccionUsuarios(value, direction, movedKeys) {
      let result = [];
      // si se movieron elementos hacia la derecha o si se esta editando un archivo, 
      // agrego los elementos movidos (o los ya seleccionados) al array de perfiles seleccionados
      if (direction == "right") {
        for (let i=0; i<movedKeys.length; i++) {
          result = this.dataUsuarios.filter(x => {
            return x.Id == movedKeys[i]
          });

          this.seleccionUsuarios.push(result[0]);
        }
      }
      
      // si se movieron elementos hacia la izquierda, los quito del array de perfiles seleccionados
      if (direction == "left") {
        for (let i=0; i<movedKeys.length; i++) {
          this.seleccionUsuarios.splice(
            this.seleccionUsuarios.findIndex((x) => x.Id == movedKeys[i]),
            1
          );
        }
      }
    },
    onArchivoChanged(name, fileUpload) {
      if (fileUpload[0])
        this.archivoCargado = {name: fileUpload[0].name };
      else
        this.archivoCargado = [];
    },

    save() {
      // indico que se est� guardando la noticia
      this.guardando = true;

      // validaciones
      let valida = true;

      if (!this.archivo.nombre) {
        showError(this.$t("ARCHIVOS_nombre_missing"));
        valida = false;
      }

      //if (!this.archivo.descripcion) {
      //  showError(this.$t("ARCHIVOS_descripcion_missing"));
      //  valida = false;
      //}
      if(this.archivo.esArchivo)
      {
        switch(this.archivo.tipoArchivo)
        {
          case 1:
            if(this.archivoCargado.length == 0)
            {
              showError(this.$t("ARCHIVOS_archivo_missing"));
              valida = false;
            }
          break;
          case 2:
            if(this.archivo.link == undefined || this.archivo.link == "")
            {
              showError(this.$t("ARCHIVOS_link_missing"));
              valida = false;
            }
          break;
         
        }
      }

      // if(this.archivo.esArchivo && this.archivo.tipoArchivo == 1 && this.archivoCargado.length==0) {
      //   showError(this.$t("ARCHIVOS_archivo_missing"));
      //   valida = false;
      // }

      if (!valida) {
        this.guardando = false;
        return;
      }

      // armo el payload
      let payload = {
        Id: this.archivo.id ? this.archivo.id : 0,
        Nombre: this.archivo.nombre,
        Descripcion: this.archivo.descripcion,
        Fecha_vencimiento: this.archivo.fecha_vencimiento,
        NombreArchivoSubido: this.archivo.tipoArchivo == 2 ? this.archivo.link : this.archivoCargado.name,
        IdCarpetaTemporal: this.idTemporal,
        PermisosPerfil: this.seleccionPerfiles.map(x => x.Id),
        PermisosUsuario: this.seleccionUsuarios.map(x => x.Id),
        Publico: this.archivo.esPublico,
        HeredaPermisos: this.archivo.heredaPermisos,
        EsArchivo: this.archivo.esArchivo,
        IdPadre: this.archivo.arrayUbicacion[this.archivo.arrayUbicacion.length-1],
        TipoArchivo: this.archivo.tipoArchivo
      };

      // persisto el archivo
      this.$store
        .dispatch("archivos/saveArchivo", payload)
        .then(codigoResultado => {
          if (codigoResultado === 0 || codigoResultado.CodigoResultado === 0) {
            showSuccess(this.$t("ARCHIVO_success"));
            this.$router.push({ name: "Archivos" });
          } else mostrarMensajeInternacionalizado(codigoResultado);
        })
        .finally(() => (this.guardando = false));
    },

    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) {
        return "background-color: var(--main-color);font-weight: bold;";
      }
    },

    setArchivo(datosArchivo) {
      // inicializo el archivo
      this.archivo.id = datosArchivo.Id;
      this.archivo.nombre = datosArchivo.Nombre;
      this.archivo.descripcion = datosArchivo.Descripcion;
      this.archivo.permisosPerfil = datosArchivo.PermisosPerfil;
      this.archivo.permisosUsuario = datosArchivo.PermisosUsuario;
      // si al momento de guardar un archivo no se establecio la fecha de vencimiento, �sta se guarda con la fecha por default
      // para no mostrar una fecha que nunca se establecio se hace el check
      this.archivo.fecha_vencimiento = datosArchivo.Fecha_vencimiento === "0001-01-01T00:00:00" ? undefined : datosArchivo.Fecha_vencimiento;
      this.archivo.esPublico = datosArchivo.Publico;
      this.archivo.esArchivo = datosArchivo.Es_archivo;
      this.archivo.heredaPermisos = datosArchivo.Hereda_permisos;
      this.archivo.tipoArchivo = datosArchivo.Tipo_archivo;
      // metodo para obtener la ubicacion jerarquica de un nodo (sin el nodo root)
      this.getUbicacion(this.jerarquiaCarpetas[0], datosArchivo.Id_padre);
      
      //seteo en el cascader la ubicacion
      this.$refs.cascader.checkedValue = [0].concat(this.destinoRecursivo.slice(1).reverse());
      if(this.archivo.tipoArchivo == 1)
        // inicializo el componente file upload
        this.archivoCargado = [{ name: datosArchivo.FileName}];
      else
        this.archivo.link = datosArchivo.FileName;
      
      if (!this.archivo.esPublico) {
        // inicializo los transfers de los permisos con sus valores
        this.valuePerfiles = datosArchivo.PermisosPerfil;
        this.valueUsuarios = datosArchivo.PermisosUsuario;

        // pusheo a los arrays de seleccion perfiles y usuarios sus objetos asociados a los values
        let resultPerfiles = [];
        for (let i=0; i<this.valuePerfiles.length; i++) {
          resultPerfiles = this.$refs.transferPerfiles.sourceData.filter(x => {
            return x.Id == this.valuePerfiles[i]
          });
         this.seleccionPerfiles.push(resultPerfiles[0]);
        }

        let resultUsuarios = [];
        for (let i=0; i<this.valueUsuarios.length; i++) {
          resultUsuarios = this.$refs.transferUsuarios.sourceData.filter(x => {
            return x.Id == this.valueUsuarios[i]
          });
         this.seleccionUsuarios.push(resultUsuarios[0]);
        }
      }


    },

    quitarHijosVacios(jerarquia) {
      // defino como undefined a los nodos hojas, porque sino el componente Cascader
      // genera una jerarquia extra (nodos hojas llegan como Hijos:[] del back)
      for (let i=0; i<jerarquia.length; i++) {
        if (jerarquia[i].Hijos.length == 0) {
          jerarquia[i].Hijos = undefined;
        }   
        else {
          this.quitarHijosVacios(jerarquia[i].Hijos);
        }
      }
    },

    agregarRaiz() {
      let temp = this.jerarquiaCarpetas;
      this.jerarquiaCarpetas = [{
        Id: 0,
        Nombre: 'Colven',
        Hijos: temp
      }];
    },

    getUbicacion(jerarquia, id_objetivo) {
      if(jerarquia.Id == id_objetivo) {
        return this.destinoRecursivo.push(jerarquia.Id);
      }
      else {
        if(jerarquia.Hijos !== undefined) { 
          for(let i=0; i<jerarquia.Hijos.length; i++) {
            let resultado = this.getUbicacion(jerarquia.Hijos[i], id_objetivo);
            if(resultado !== undefined) {
              return this.destinoRecursivo.push(jerarquia.Hijos[i].Id);	
            }
          }
        }
        else {
          return;
        }
      }		
    }
  },
  mounted()
  {
    if (this.$route.params.id) {
        // indico que es una edici�n de un archivo
        this.esEdicion = true;

        // busco la solicitud a editar
        let requestArchivo = this.$store
          .dispatch("archivos/getArchivo", { id: this.$route.params.id })
          .then(data => {
            if (data.CodigoResultado === 0) 
              this.archivoTemporal = data.Datos;
            else
              mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado);
          });
        Promise.all([requestArchivo, this.getJerarquiaCarpetas()]).then(() => {
          this.cargandoArchivo = false;
          this.setArchivo(this.archivoTemporal);
        })
      }
      else {
        this.archivo.heredaPermisos = false;
        this.archivo.esArchivo = true;
        this.archivo.esPublico = false;
        this.archivo.tipoArchivo = 1;
        this.getJerarquiaCarpetas()
        this.cargandoArchivo = false;
      }
      
  },
  created()
  {
    this.getPerfiles();
    this.getUsuarios();
  }
};
</script>

<style scoped>
  .loader
  {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 304px;
  }
  .loader i
  {
    color:var(--main-color);
    font-size: 50px;
  }
  .loader .text-loader
  {
    font-size: 12px;
    margin-top: 5px;
  }

.container_cards {
  display: flex;
}
.cardArchivo {
  min-height: 300px;
  flex: 50%;
}
.cardPermisos {
  min-height: 426px;
  flex: 50%;
}

@media (max-width: 1000px) {
  .container_cards {
    flex-direction: column;
  }
  .cardPermisos {
    flex: 50%;
    margin-top: 20px;
    margin-left: 0;
  }
}

.tablaPermisos {
  width: 95%;
  margin-top: 5px !important;
}
.cardTitle {
  font-size: 18px;
  line-height: 26px;
  font-weight: 600;
  text-align: left;
  color: black;
}
.title {
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: var(--main-color);
  text-align: left;
  margin-bottom: 20px;
}

.container {
  padding: 0 30px;
  margin: 0 auto;
}
.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.label {
  text-align: left;
  font-size: 14px;
  margin-bottom: 4px;
  margin-top: 15px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  font-size: 14px;
  color: #666;
}
.button {
  position: fixed;
  bottom: 40px;
  right: 40px;
}

.cardGuardado {
  width: 70%;
  margin-left: 15%;
  margin-right: 15%;
}
.btnContainer {
  margin-top: 30px;
}

.checkboxPublicoContainer {
  text-align: right;
}

.seleccionador{
  float: left;
}
</style>

<style>
.fileUploadButton .el-button {
  height:32px ;
  line-height:5px ;
}

.el-table th > .cell {
  color: #fff !important;
}

.el-checkbox, .el-checkbox__input:not(first) {
  display:flex;
}

.el-cascader {
  width:100%;
}

.el-transfer-panel__item.el-checkbox .el-checkbox__label {
  display:flex;
}
  
.transferClass .el-transfer-panel {
  margin-left: 0px;
  width: 170px;
}

.transferClass .el-checkbox__input {
  margin-left: -10px;
}

.transferClass .el-checkbox {
  font-size: 11px;
}

.transferClass .el-checkbox__label {
  font-size: 11px;
  margin-left: -10px;
}

.transferClass .el-transfer__buttons {
  padding: 0 5px;
}

.transferClass .el-button {
  width: 20px;
  padding: 12px 20px !important;
}
</style>